import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Space as AntSpace } from 'antd';
import React, { FC } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { SettingsLabelWithoutMargin } from '../styles';
import { Description, Space, TitleHelper } from './custom-domain.styles';

export const VerifyDomain: FC<{
  onVerify: () => void;
  loading?: boolean;
  verificationStatus?: boolean;
  isError?: boolean;
}> = ({ onVerify, loading = false, verificationStatus, isError }) => {
  const title = useTranslation('settings.custom_domain.step.title', {
    current: 2,
    total: 2,
  });
  const description = useTranslation(
    'settings.custom_domain.step.two.description',
  );
  const buttonText = useTranslation('settings.custom_domain.verify.text');
  const loadingText = useTranslation('verifying');
  const helpText = useTranslation('settings.custom_domain.step.two.help');
  const errorText = useTranslation('settings.custom_domain.step.two.error');

  return (
    <Space size="large">
      <AntSpace>
        <SettingsLabelWithoutMargin>{title}:</SettingsLabelWithoutMargin>
        <TitleHelper>{description}</TitleHelper>
      </AntSpace>
      <Space>
        <Button
          icon={<ArrowRight16 />}
          iconPlacement="right"
          onClick={onVerify}
          loading={loading}
        >
          {loading ? loadingText : buttonText}
        </Button>

        {isError ? <Description color="error">{errorText}</Description> : null}
        {verificationStatus === false ? (
          <Description color="success">{helpText}</Description>
        ) : null}
      </Space>
    </Space>
  );
};
